module.exports = __webpack_public_path__ + "static/media/jp.776b80f7.svg";